import { Suspense } from "react";
import { useAtomValue } from "jotai";
import { Tooltip } from "@zapier/design-system-beta";
import { Button } from "@zapier/design-system";
import { Icon } from "@zapier/zinnia-icons";

import { isZapPublishedAtomFamily_SUSPENDS } from "@zapier/canvas-state";
import { useEmitUserInteractionEvents } from "../../hooks/useEmitUserInteractionEvents";

type Props = { zapId: string; location: "sidebar" | "node" };

function SuspendedZapLink({ zapId, location }: Props) {
  const isPublished = useAtomValue(isZapPublishedAtomFamily_SUSPENDS(zapId));
  const { emitEventOnAssetOpen } = useEmitUserInteractionEvents();

  // This means the zap is not found or a zsl template zap
  if (isPublished === null) {
    return null;
  }

  const editorLink = `/editor/${zapId}`;

  return (
    <Tooltip placement="top" content="Open Zap">
      <Tooltip.FocusableTrigger>
        <Button
          size="small"
          iconPosition="start"
          onPress={async () => {
            emitEventOnAssetOpen({
              asset: "zap",
              location,
            });
            window.open(editorLink, "_blank");
          }}
        >
          <Icon name="arrowOffsite" size={20} color="BackgroundDefault" />
          Edit
        </Button>
      </Tooltip.FocusableTrigger>
    </Tooltip>
  );
}

export function ZapLink({ zapId, location }: Props) {
  return (
    <Suspense fallback={null}>
      <SuspendedZapLink zapId={zapId} location={location} />
    </Suspense>
  );
}
